export const appTitle = import.meta.env.VITE_APP_TITLE
export const arAPIURL = import.meta.env.VITE_APP_AR_API
